export default __webpack_public_path__ + "static/media/forensics.6fba9a4d.jpg";